(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
  var overlay = document.getElementById('cartDrawerOverlay');
  var drawer = document.getElementById('cartDrawer');
  var itemsContainer = document.getElementById('cartDrawerItems');
  var emptyState = document.getElementById('cartDrawerEmpty');
  var footer = document.getElementById('cartDrawerFooter');
  var totalEl = document.getElementById('cartDrawerTotal');
  var noteEl = document.getElementById('cartDrawerNote');
  var floatingBtn = document.getElementById('floatingCartBtn');
  var floatingCount = document.getElementById('floatingCartCount');
  var freeShipEl = document.getElementById('cartFreeShipping');
  var freeShipText = document.getElementById('cartFreeShippingText');
  var freeShipFill = document.getElementById('cartFreeShippingFill');
  var config = window.__cartConfig || {};

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var b = '{' + '{';
    var e = '}' + '}';
    var format = config.moneyFormat || ('$' + b + 'amount' + e);
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    var amountWithComma = amount.replace('.', ',');
    var amountNoDecimalsWithComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(b + 'amount_with_comma_separator' + e, amountWithComma)
      .replace(b + 'amount_no_decimals_with_comma_separator' + e, amountNoDecimalsWithComma)
      .replace(b + 'amount_no_decimals' + e, amountNoDecimals)
      .replace(b + 'amount' + e, amount);
  }

  function renderFreeShipping(cart) {
    var threshold = config.freeShippingThreshold || 0;
    if (!freeShipEl || threshold <= 0) return;

    if (cart.item_count === 0) {
      freeShipEl.style.display = 'none';
      return;
    }
    freeShipEl.style.display = '';

    var remaining = threshold - cart.total_price;
    var unlocked = remaining <= 0;

    freeShipEl.classList.toggle('cart-free-shipping--unlocked', unlocked);
    freeShipFill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    freeShipText.textContent = unlocked
      ? (config.strings.freeShippingUnlocked || '')
      : (config.strings.freeShippingProgress || '').replace('__amount__', formatMoney(remaining));
  }

  function updateUI(cart) {
    renderFreeShipping(cart);
    if (cart.item_count > 0) {
      floatingBtn.style.display = 'flex';
      floatingCount.textContent = cart.item_count;
    } else {
      floatingBtn.style.display = 'none';
    }
    var headerCount = document.querySelector('.premium-header__cart-count');
    if (headerCount) {
      headerCount.textContent = cart.item_count;
      headerCount.style.display = cart.item_count > 0 ? '' : 'none';
    }
  }

  function render(cart) {
    updateUI(cart);
    if (cart.item_count === 0) {
      emptyState.style.display = 'flex';
      itemsContainer.innerHTML = '';
      footer.style.display = 'none';
      return;
    }
    emptyState.style.display = 'none';
    footer.style.display = 'flex';
    totalEl.innerHTML = '<span>' + escapeHtml(config.strings.subtotal || 'Subtotal') + '</span><span>' + formatMoney(cart.total_price) + '</span>';

    itemsContainer.innerHTML = cart.items.map(itemHTML).join('');

    if (noteEl && cart.note) {
      noteEl.value = cart.note;
    }
  }

  function itemHTML(item) {
      var img = item.image
        ? '<img class="cart-drawer-item__img" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '<div class="cart-drawer-item__img cart-drawer-item__img--placeholder"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-drawer-item__variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';
      return '<div class="cart-drawer-item" data-line-key="' + escapeHtml(item.key) + '">' +
        img +
        '<div class="cart-drawer-item__info">' +
          '<a href="' + item.url + '" class="cart-drawer-item__name">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<div class="cart-drawer-item__row">' +
            '<span class="cart-drawer-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '<div class="cart-drawer-item__qty">' +
              '<button type="button" aria-label="Decrease" onclick="window.CartDrawer.updateItem(&#39;' + item.key + '&#39;,' + (item.quantity - 1) + ')">&#8722;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" aria-label="Increase" onclick="window.CartDrawer.updateItem(&#39;' + item.key + '&#39;,' + (item.quantity + 1) + ')">+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cart-drawer-item__remove" onclick="window.CartDrawer.updateItem(&#39;' + item.key + '&#39;,0)">' + escapeHtml(config.strings.remove || 'Remove') + '</button>' +
        '</div>' +
      '</div>';
  }

  function showDrawer() {
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  async function open() {
    /* Contents are server-rendered and kept in sync by every mutation,
       so show them straight away and only reconcile in the background. */
    showDrawer();
    try {
      render(await (await fetch('/cart.js')).json());
    } catch (e) {
      /* Keep whatever is already on screen. */
      console.error('Cart refresh error:', e);
    }
  }

  function close() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  async function updateItem(lineKey, quantity) {
    var qty = Math.max(0, quantity);
    var key = String(lineKey);

    /* Optimistic UI: reflect the change immediately, before the network call. */
    var row = itemsContainer
      ? itemsContainer.querySelector('[data-line-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]')
      : null;
    if (row) {
      if (qty === 0) {
        row.style.display = 'none';
      } else {
        row.style.opacity = '.5';
        row.style.pointerEvents = 'none';
      }
    }

    try {
      /* /cart/change.js already returns the updated cart — no second round trip needed. */
      var changeRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!changeRes.ok) {
        var errBody = await changeRes.json().catch(function () { return {}; });
        throw new Error(errBody.description || errBody.message || 'Cart change failed');
      }
      render(await changeRes.json());
    } catch (e) {
      console.error('Cart update error:', e);
      /* Roll back the optimistic change from the server's truth. */
      if (row) {
        row.style.display = '';
        row.style.opacity = '';
        row.style.pointerEvents = '';
      }
      try { render(await (await fetch('/cart.js')).json()); } catch (_) {}
    }
  }

  async function addItem(variantId, quantity) {
    /* Open right away so the click feels instant, then reconcile. */
    showDrawer();
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
      });
      if (!res.ok) {
        var err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || err.message || config.strings.error || 'Error adding to cart');
      }
      /* /cart/add.js returns the line it created — paint it before the full cart lands. */
      var added = await res.json().catch(function () { return null; });
      if (added && added.key && itemsContainer) {
        var existing = itemsContainer.querySelector('[data-line-key="' + (window.CSS && CSS.escape ? CSS.escape(added.key) : added.key) + '"]');
        if (existing) {
          existing.outerHTML = itemHTML(added);
        } else {
          itemsContainer.insertAdjacentHTML('beforeend', itemHTML(added));
        }
        if (emptyState) emptyState.style.display = "none";
        if (footer) footer.style.display = "";
      }

      render(await (await fetch('/cart.js')).json());
      return true;
    } catch (e) {
      console.error('Add to cart error:', e);
      /* Show the cart's real state, then report the failure. */
      try { render(await (await fetch('/cart.js')).json()); } catch (_) {}
      alert(e.message || config.strings.error || 'Could not add to cart');
      return false;
    }
  }

  async function updateNote() {
    if (!noteEl) return;
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteEl.value })
      });
    } catch (e) {
      console.error('Note update error:', e);
    }
  }

  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
  if (floatingBtn) floatingBtn.addEventListener('click', function() { open(); });

  var noteTimer;
  if (noteEl) noteEl.addEventListener('input', function() {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(updateNote, 800);
  });

  var closeBtn = drawer ? drawer.querySelector('.cart-drawer-close') : null;
  if (closeBtn) closeBtn.addEventListener('click', close);

  fetch('/cart.js').then(function(r) { return r.json(); }).then(updateUI).catch(function() {});

  window.CartDrawer = { open: open, close: close, render: render, updateItem: updateItem, addItem: addItem, formatMoney: formatMoney, updateUI: updateUI };
})();
  } catch(e) { console.error(e); }
})();

})();
